// getStreamTokenDecodedData.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';

/**
 * Select stream token decoded data by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {null|object} stream token decoded data or null.
 */
const getStreamTokenDecodedData = createCachedSelector(
  (state, streamId) =>
    getOperationData(state, ['liveStream', 'paid', streamId, 'decodedToken']),
  decodedToken => {
    if (!decodedToken) {
      return null;
    }

    return decodedToken;
  }
)((state, streamId) => `${streamId}`);

export default getStreamTokenDecodedData;
